import { render, staticRenderFns } from "./ButtonList.vue?vue&type=template&id=d1935c92&scoped=true&"
import script from "./ButtonList.vue?vue&type=script&lang=js&"
export * from "./ButtonList.vue?vue&type=script&lang=js&"
import style0 from "./ButtonList.vue?vue&type=style&index=0&id=d1935c92&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1935c92",
  null
  
)

export default component.exports